export default "__VITE_ASSET__CmkuoTKQ__"